import axios from 'axios';
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = '/index.php';

export default {
    namespaced: true,
    state: {
        records: [],
        columns: [],
        stat: [],
        userColumns: [],
        permissions: {
            canAllDelete: false,
            canDeleteFiilals: [],
        },
        mainTableCalculationByDate: {
            actions: false,
            levels: 1,
            columns: [
                {
                    id: 'post',
                    label: 'Должность',
                    fullName: 'Должность',
                    type: 'string',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'loadType',
                    label: 'Тип нагрузки',
                    fullName: 'Тип нагрузки',
                    type: 'string',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'string',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'pluski',
                    label: 'Плюшки',
                    fullName: 'Скидки Плюшки',
                    type: 'string',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'revenue_plus_bonuses',
                    label: 'Выручка + плюшки',
                    fullName: 'Выручка + плюшки',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'additionalLoad',
                    label: 'Доп. нагрузка',
                    fullName: 'Дополнительная нагрузка',
                    type: 'string',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employees',
                    label: 'Сотр.',
                    fullName: 'Сотрудники',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'hours',
                    label: 'Часы',
                    fullName: 'Часы',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'fotInCategory',
                    label: 'ФОТ, %',
                    fullName: 'ФОТ, %',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'fotFromProceeds',
                    label: 'Выручка, %',
                    fullName: 'Выручка, %',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'productionRate',
                    label: 'Норм. выр-ки, %',
                    fullName: 'Норма выработки, %',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },

                {
                    id: 'lateness',
                    label: 'Опоздания',
                    fullName: 'Опоздания',
                    type: 'string',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
            ],
            records: [
                {
                    postCode: 'driver',
                    post: {
                        value: 'Водители',
                    },
                    loadType: {
                        value: 'Выручка',
                    },
                    load: {
                        value: 0,
                        unit: '฿',
                    },
                    additionalLoad: {
                        value: 0,
                    },
                    pluski: {
                        value: '',
                    },
                    revenue_plus_bonuses: {
                        value: 0,
                        unit: '฿',
                    },
                    employees: {
                        value: 0,
                    },
                    hours: {
                        value: 0,
                    },
                    fotInCategory: {
                        value: 0,
                    },
                    fotFromProceeds: {
                        value: 0,
                    },
                    productionRate: {
                        value: 0,
                    },
                    lateness: {
                        value: ['', '', '', ''],
                    },
                    isShowRow: true,
                },
                {
                    isSumRow: true,
                    post: {
                        value: '',
                    },
                    loadType: {
                        value: '',
                    },
                    load: {
                        value: 0,
                        unit: '฿',
                    },
                    additionalLoad: {
                        value: '',
                    },
                    pluski: {
                        value: 0,
                    },
                    revenue_plus_bonuses: {
                        value: 0,
                        unit: '฿',
                    },
                    employees: {
                        value: 0,
                    },
                    hours: {
                        value: 0,
                    },

                    fotInCategory: {
                        value: 0,
                    },
                    fotFromProceeds: {
                        value: 0,
                    },
                    productionRate: {
                        value: 0,
                    },
                    lateness: {
                        value: [0, 0, 0, 0],
                    },
                    isShowRow: true,
                },
            ],
        },
        mainTableCalculationByPeriod: {
            actions: false,
            levels: 1,
            columns: [
                {
                    id: 'post',
                    label: 'Должность',
                    fullName: 'Должность',
                    type: 'string',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'loadType',
                    label: 'Тип нагрузки',
                    fullName: 'Тип нагрузки',
                    type: 'string',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employees',
                    label: 'Сотр.',
                    fullName: 'Сотрудники',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'payments',
                    label: 'ФОТ, %',
                    fullName: 'ФОТ, %',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'fotFromProceeds',
                    label: 'Выработка, %',
                    fullName: 'Выработка, %',
                    type: 'number',
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
            ],
            records: [
                {
                    postCode: 'driver',
                    post: {
                        value: 'Водители',
                    },
                    loadType: {
                        value: 'Выручка',
                    },
                    pluski: {
                        value: '',
                    },
                    employees: {
                        value: 0,
                    },
                    hours: {
                        value: 0,
                    },
                    fotFromProceeds: {
                        value: 0,
                    },
                    payments: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    isSumRow: true,
                    post: {
                        value: '',
                    },
                    loadType: {
                        value: '',
                    },
                    pluski: {
                        value: 0,
                    },
                    employees: {
                        value: 0,
                    },
                    hours: {
                        value: 0,
                    },
                    fotFromProceeds: {
                        value: 0,
                    },
                    payments: {
                        value: 0,
                    },
                    isShowRow: true,
                },
            ],
        },
        tableProductionNewCalculation: {
            type: 'new-calculation-production',
            actions: false,
            levels: 1,
            columns: [
                {
                    id: 'employee',
                    label: 'Сотрудник',
                    fullName: 'Сотрудник',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'premium_personal_account',
                    label: 'ЛС, ฿',
                    fullName: 'Личный счет, ฿',
                    type: 'date',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_transactions',
                    label: 'Операции с ЛС, ฿',
                    fullName: 'Операции с личным счетом, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'rank',
                    label: 'Разряд',
                    fullName: 'Разряд',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'working_interval',
                    label: 'Начало/конец работы',
                    fullName: 'Начало/конец работы',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'amount_working_time',
                    label: 'Рабочее время',
                    fullName: 'Рабочее время',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'compensation',
                    label: 'Компенс.',
                    fullName: 'Компенсация',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'salary',
                    label: 'Оклад, ฿',
                    fullName: 'Оклад, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'main_part_salary',
                    label: 'Осн. часть зп, ฿',
                    fullName: 'Основная часть зарплаты, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'revenue_standard_hour',
                    label: 'Норм. выр-ки/ч',
                    fullName: 'Норматив выручки/ч',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'ratio_standart',
                    label: 'Коэфф. норм.',
                    fullName: 'Коэффициент норматива',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'revenue_standard',
                    label: 'Норм. выр-ки',
                    fullName: 'Норматив выручки',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'bonus_rate',
                    label: 'Коэфф. прем.-я',
                    fullName: 'Коэффициент премирования',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'deprivation_coefficient',
                    label: 'Коэфф. депр.-я',
                    fullName: 'Коэффициент депремирования',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'corrected_time',
                    label: 'Корр. время',
                    fullName: 'Корректированное время',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'sum_deposit',
                    label: 'Депозит',
                    fullName: 'Депозит',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'premium_for_exceeding_standard',
                    label: 'Премия за прев. норм., ฿',
                    fullName: 'Премия за превышение норматива, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'depreciation',
                    label: 'Депр., ฿',
                    fullName: 'Депремирование, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'prize',
                    label: 'Премия, ฿',
                    fullName: 'Премия, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'fine',
                    label: 'Штраф',
                    fullName: 'Штраф',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_accrued',
                    label: 'Всего начислено, ฿',
                    fullName: 'Всего начислено, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'to_payoff',
                    label: 'К выплате, ฿',
                    fullName: 'К выплате, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
            ],
            records: [
                {
                    groupName: 'total',
                    records: [
                        {
                            isTotalRow: true,
                            employee: {
                                value: null,
                            },
                            premium_personal_account: {
                                value: null,
                            },
                            personal_account_transactions: {
                                value: null,
                            },
                            rank: {
                                value: null,
                            },
                            working_interval: {
                                value: null,
                            },
                            amount_working_time: {
                                value: '00:00',
                            },
                            compensation: {
                                value: null,
                            },
                            release_from_load: {
                                value: null,
                            },
                            load: {
                                value: null,
                            },
                            salary: {
                                value: null,
                            },
                            main_part_salary: {
                                value: 0,
                            },
                            revenue_standard_hour: {
                                value: null,
                            },
                            ratio_standart: {
                                value: 0,
                            },
                            revenue_standard: {
                                value: 0,
                            },
                            bonus_rate: {
                                value: 0,
                            },
                            deprivation_coefficient: {
                                value: 0,
                            },
                            corrected_time: {
                                value: '00:00',
                            },
                            sum_deposit: {
                                value: 0,
                            },
                            premium_for_exceeding_standard: {
                                value: 0,
                            },
                            depreciation: {
                                value: null,
                            },
                            prize: {
                                value: null,
                            },
                            fine: {
                                value: null,
                            },
                            total_accrued: {
                                value: 0,
                            },
                            to_payoff: {
                                value: 0,
                            },
                            isShowRow: true,
                        },
                    ],
                },
            ],
        },
        tableProductionByPeriod: {
            type: 'new-calculation-production',
            actions: false,
            levels: 1,
            columns: [
                {
                    id: 'employee',
                    label: 'Сотрудник',
                    fullName: 'Сотрудник',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'premium_personal_account',
                    label: 'ЛС, ฿',
                    fullName: 'Личный счет на момент создания расчетной смены. динамически меняется в зависимости от дня просмотра',
                    type: 'date',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'balance',
                    label: 'Баланс на дату, ฿',
                    fullName: 'Показывает сумму всех начислений и списаний по счету, плюс начальный остаток',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_transactions',
                    label: 'Операции с ЛС, ฿',
                    fullName: 'Операции с личным счетом, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: 'Используется для создания операции сейчас, в рамках расчетной смены. Можно создавать неограниченное количество операций начисления и списания в рамках одной расчетной смены.',
                },
                {
                    id: 'total_accrued',
                    label: 'Всего начислено, ฿',
                    fullName: 'Показывает какая сумма была начислена на личный счет за весь период. Начисленные премии увеличивают эту сумму, а начисленные штрафы никак на нее не влияют. Они отражаются в столбце "Всего списано"',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'already_paid',
                    label: 'Всего списано, ฿',
                    fullName: 'Показывает все проводки списания с личного счета, сделанные любым способом, в том числе штрафы, выплаченные через личный счет или расчетную смену деньги',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'to_payoff',
                    label: 'К выплате, ฿',
                    fullName: 'Показывает, сколько сотруднику осталось выплатить денег в рамках данной расчетной смены. Когда выплачено все что полагается, правильное значение ячейки 0',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },

                {
                    id: 'personal_account_accrued',
                    label: 'Начислено на ЛС, ฿',
                    fullName: 'Сумма начислений за отчетный период',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_removed',
                    label: 'Снято c ЛС, ฿',
                    fullName: 'Сумма списаний за отчетный период',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_balance',
                    label: 'Остаток на ЛС, ฿',
                    fullName: 'Показывает остаток на ЛС после созданных проводок в рамках данной расчетной смены. На момент создания расчетной смены всегда будет равен столбцу',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'period_rank',
                    label: 'Разряд',
                    fullName: 'Разряд',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'count_smenas',
                    label: 'Кол-во смен',
                    fullName: 'Кол-во смен за отчетный период',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'period_working_time',
                    label: 'Рабочее время',
                    fullName: 'Рабочее время',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'period_compensation',
                    label: 'Компенс.',
                    fullName: 'Компенсация',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'salary',
                    label: 'Оклад, ฿',
                    fullName: 'Показывает сумму заработной платы за 12 часов рабочего времени исходя из настроек должности и разрядов.',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'main_part_salary',
                    label: 'Осн. часть зп, ฿',
                    fullName: 'Основная часть зарплаты, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'corrected_time',
                    label: 'Корр. время',
                    fullName: 'Корректированное время',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'sum_deposit',
                    label: 'Депозит, ฿',
                    fullName: 'Cумма списаний на депозит за отчетный период',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'premium_for_exceeding_standard',
                    label: 'Премия за прев. норм., ฿',
                    fullName: 'Премия за превышение норматива, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'depreciation',
                    label: 'Депр., ฿',
                    fullName: 'Депремирование, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'prize',
                    label: 'Премия, ฿',
                    fullName: 'Показывает сумму всех премий, начисленных за отчетный период. При клике можно просмотреть подробности по каждой премии. В рамках расчетной смены можно добавить новые премии, они будут начислены датой расчетной смены. При начислении премии изменяется поле "Всего начислено" и "К выплате"',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'fine',
                    label: 'Штраф',
                    fullName: 'Показывает сумму всех штрафов, начисленных за отчетный период. При клике можно просмотреть подробности по каждому штрафу. В рамках расчетной смены можно добавить новые штрафы, они будут начислены датой расчетной смены. При начислении штрафа изменяется поле "Всего списано" и "К выплате"',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
            ],
            records: [
                {
                    groupName: 'total',
                    records: [
                        {
                            isTotalRow: true,
                            employee: {
                                value: null,
                            },
                            premium_personal_account: {
                                value: null,
                            },
                            personal_account_transactions: {
                                value: null,
                            },
                            personal_account_accrued: {
                                value: null,
                            },
                            personal_account_removed: {
                                value: null,
                            },
                            balance: {
                                value: 0,
                            },
                            sum_deposit: {
                                value: 0,
                            },
                            personal_account_balance: {
                                value: null,
                            },
                            count_smenas: {
                                value: null,
                            },
                            period_working_time: {
                                value: '00:00',
                            },
                            period_rank: {
                                value: null,
                            },
                            period_compensation: {
                                value: null,
                            },
                            load: {
                                value: null,
                            },
                            salary: {
                                value: null,
                            },
                            main_part_salary: {
                                value: 0,
                            },
                            revenue_standard_hour: {
                                value: null,
                            },
                            ratio_standart: {
                                value: 0,
                            },
                            revenue_standard: {
                                value: 0,
                            },
                            bonus_rate: {
                                value: 0,
                            },
                            deprivation_coefficient: {
                                value: 0,
                            },
                            corrected_time: {
                                value: '00:00',
                            },
                            premium_for_exceeding_standard: {
                                value: 0,
                            },
                            depreciation: {
                                value: null,
                            },
                            prize: {
                                value: null,
                            },
                            fine: {
                                value: null,
                            },
                            total_accrued: {
                                value: 0,
                            },
                            already_paid: {
                                value: 0,
                            },
                            to_payoff: {
                                value: 0,
                            },
                            isShowRow: true,
                        },
                    ],
                },
            ],
        },
        tableDeliveryNewCalculation: {
            type: 'save-calculation-delivery',
            actions: false,
            levels: 1,
            columns: [
                {
                    id: 'employee',
                    label: 'Сотрудник',
                    fullName: 'Сотрудник',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'post2',
                    label: 'Должность',
                    fullName: 'Должность',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'premium_personal_account',
                    label: 'ЛС, ฿',
                    fullName: 'Личный счет, ฿',
                    type: 'date',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_transactions',
                    label: 'Операции с ЛС, ฿',
                    fullName: 'Операции с личным счетом, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'working_interval',
                    label: 'Начало/конец работы',
                    fullName: 'Начало/конец работы',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'amount_working_time',
                    label: 'Рабочее время',
                    fullName: 'Рабочее время',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'number_of_orders',
                    label: 'Кол-во заказов',
                    fullName: 'Количество заказов',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'order_value',
                    label: 'Стоимость заказов, ฿',
                    fullName: 'Стоимость заказов, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'average_check',
                    label: 'Средний чек, ฿',
                    fullName: 'Средний чек, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'distance',
                    label: 'Расстояние, км',
                    fullName: 'Расстояние, км',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'travel_time_calculation',
                    label: 'Расчет. время в пути',
                    fullName: 'Расчетное время в пути',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'actual_travel_time',
                    label: 'Факт. время в пути',
                    fullName: 'Факт. время в пути',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'kpi',
                    label: 'KPI',
                    fullName: 'KPI',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'idle_time',
                    label: 'Время без дела, %',
                    fullName: 'Время без дела, %',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'time',
                    label: 'Время',
                    fullName: 'Время',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'sum_orders',
                    label: 'Заказы',
                    fullName: 'Заказы',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'money_per_distance',
                    label: 'Расст.',
                    fullName: 'Деньги за расстояние',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'minimum_wage',
                    label: 'Min оплата, ฿',
                    fullName: 'Min оплата, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'allowance',
                    label: 'Надбавка, ฿',
                    fullName: 'Надбавка, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'late_checkout_surcharge',
                    label: 'Надб. за поздний выезд, ฿',
                    fullName: 'Надбавка за поздний выезд, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'short_shift_allowance',
                    label: 'Надб. за короткую cмену, ฿',
                    fullName: 'Надбавка за короткую смену, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'sum_deposit',
                    label: 'Депозит',
                    fullName: 'Депозит',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'prize',
                    label: 'Премия, ฿',
                    fullName: 'Премия, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'fine',
                    label: 'Штраф',
                    fullName: 'Штраф',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_accrued',
                    label: 'Всего начислено, ฿',
                    fullName: 'Всего начислено, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'to_payoff',
                    label: 'К выплате, ฿',
                    fullName: 'К выплате, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
            ],
            records: [
                {
                    isTotalRow: true,
                    employee: {
                        value: null,
                    },
                    post2: {
                        value: null,
                    },
                    sum_deposit: {value: null},
                    premium_personal_account: {
                        value: null,
                    },
                    personal_account_transactions: {
                        value: null,
                    },
                    working_interval: {
                        value: null,
                    },
                    amount_working_time: {
                        value: '00:00',
                    },
                    number_of_orders: {
                        value: 0,
                    },
                    order_value: {
                        value: 0,
                    },
                    average_check: {
                        value: 0,
                    },
                    travel_time_calculation: {
                        value: '00:00',
                    },
                    actual_travel_time: {
                        value: '00:00',
                    },
                    kpi: {
                        value: 0,
                    },
                    idle_time: {
                        value: 0,
                    },
                    time: {
                        value: 0,
                    },
                    sum_orders: {
                        value: 0,
                    },
                    money_per_distance: {
                        value: 0,
                    },
                    distance: {
                        value: 0,
                    },
                    minimum_wage: {
                        value: null,
                    },
                    allowance: {
                        value: null,
                    },
                    late_checkout_surcharge: {
                        value: 0,
                    },
                    short_shift_allowance: {
                        value: 0,
                    },
                    prize: {
                        value: 0,
                    },
                    fine: {
                        value: 0,
                    },
                    total_accrued: {
                        value: 0,
                    },
                    to_payoff: {
                        value: 0,
                    },
                    isShowRow: true,
                },
            ],
        },
        tableDeliveryByPeriod: {
            type: 'save-calculation-delivery',
            actions: false,
            levels: 1,
            columns: [
                {
                    id: 'employee',
                    label: 'Сотрудник',
                    fullName: 'Сотрудник',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'premium_personal_account',
                    label: 'ЛС, ฿',
                    fullName: 'личный счет, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'balance',
                    label: 'Баланс на дату, ฿',
                    fullName: 'Баланс на дату, ฿',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_transactions',
                    label: 'Операции с ЛС, ฿',
                    fullName: 'Операции с личным счетом, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_accrued',
                    label: 'Всего начислено, ฿',
                    fullName: 'Всего начислено, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'already_paid',
                    label: 'Всего списано, ฿',
                    fullName: 'Всего списано, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'to_payoff',
                    label: 'К выплате, ฿',
                    fullName: 'К выплате, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_accrued',
                    label: 'Начислено на ЛС, ฿',
                    fullName: 'Начислено на ЛС зв период, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_removed',
                    label: 'Снято с ЛС, ฿',
                    fullName: 'Снято с ЛС за период, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'personal_account_balance',
                    label: 'Остаток на ЛС, ฿',
                    fullName: 'Остаток на ЛС, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'count_smenas',
                    label: 'Кол-во смен',
                    fullName: 'Количество смен',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'period_working_time',
                    label: 'Рабочее время',
                    fullName: 'Рабочее время',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'orders',
                    label: 'Кол-во заказов',
                    fullName: 'Кол-во заказов',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'order_value',
                    label: 'Стоимость заказов, ฿',
                    fullName: 'Стоимость заказов, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'average_check',
                    label: 'Средний чек, ฿',
                    fullName: 'Средний чек, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'distance',
                    label: 'Расстояние, км',
                    fullName: 'Расстояние, км',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'travel_time_calculation',
                    label: 'Расчет. время в пути',
                    fullName: 'Расчетное время в пути',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'actual_travel_time',
                    label: 'Факт. время в пути',
                    fullName: 'Факт. время в пути',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'kpi',
                    label: 'KPI',
                    fullName: 'KPI',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'idle_time',
                    label: 'Время без дела, %',
                    fullName: 'Время без дела, %',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'time',
                    label: 'Время',
                    fullName: 'Время',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'sum_orders',
                    label: 'Заказы',
                    fullName: 'Заказы',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'money_per_distance',
                    label: 'Расст.',
                    fullName: 'Деньги за расстояние',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'allowance',
                    label: 'Надбавка, ฿',
                    fullName: 'Надбавка, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'late_checkout_surcharge',
                    label: 'Надб. за поздний выезд, ฿',
                    fullName: 'Надбавка за поздний выезд, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'short_shift_allowance',
                    label: 'Надб. за короткую cмену, ฿',
                    fullName: 'Надбавка за короткую смену, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'sum_deposit',
                    label: 'Депозит, ฿',
                    fullName: 'Депозит, ฿',
                    type: 'number',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'prize',
                    label: 'Премия, ฿',
                    fullName: 'Премия, ฿',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'fine',
                    label: 'Штраф',
                    fullName: 'Штраф',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },

            ],
            records: [
                {
                    isTotalRow: true,
                    employee: {
                        value: null,
                    },
                    sum_orders: {
                        value: 0,
                    },
                    premium_personal_account: {
                        value: null,
                    },
                    balance: {
                        value: null,
                    },
                    sum_deposit: {
                        value: null,
                    },
                    personal_account_transactions: {
                        value: null,
                    },
                    personal_account_accrued: {
                        value: null,
                    },
                    personal_account_removed: {
                        value: null,
                    },
                    personal_account_balance: {
                        value: 0,
                    },
                    count_smenas: {
                        value: null,
                    },
                    period_working_time: {
                        value: '00:00',
                    },
                    order_value: {
                        value: 0,
                    },
                    average_check: {
                        value: 0,
                    },
                    travel_time_calculation: {
                        value: '00:00',
                    },
                    actual_travel_time: {
                        value: '00:00',
                    },
                    kpi: {
                        value: 0,
                    },
                    idle_time: {
                        value: 0,
                    },
                    time: {
                        value: 0,
                    },
                    orders: {
                        value: 0,
                    },
                    money_per_distance: {
                        value: 0,
                    },
                    distance: {
                        value: 0,
                    },
                    minimum_wage: {
                        value: null,
                    },
                    allowance: {
                        value: null,
                    },
                    late_checkout_surcharge: {
                        value: 0,
                    },
                    short_shift_allowance: {
                        value: 0,
                    },
                    prize: {
                        value: 0,
                    },
                    fine: {
                        value: 0,
                    },
                    total_accrued: {
                        value: 0,
                    },
                    already_paid: {
                        value: 0,
                    },
                    to_payoff: {
                        value: 0,
                    },
                    isShowRow: true,
                },
            ],
        },
        tableLatenessNewCalculation: {
            type: 'new-calculation-lateness',
            actions: false,
            levels: 1,
            columns: [
                {
                    id: 'total',
                    label: 'Время',
                    fullName: '',
                    type: 'string',
                    level: 0,
                    isCategory: 1,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'operator',
                    label: 'Оператор',
                    fullName: 'Оператор',
                    type: 'string',
                    isCategory: 1,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'corf_operator',
                    label: 'КОРФ',
                    fullName: 'КОРФ',
                    type: 'string',
                    level: 1,
                    isCategory: 0,
                    parentColumnId: 'operator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load_operator',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'string',
                    level: 1,
                    isCategory: 0,
                    parentColumnId: 'operator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employees_operator',
                    label: 'Сотр.',
                    fullName: 'Сотрудники',
                    type: 'string',
                    level: 1,
                    isCategory: 0,
                    parentColumnId: 'operator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'number_orders_operator',
                    label: 'Кол-во заказов',
                    fullName: 'Количество заказов',
                    type: 'string',
                    level: 1,
                    isCategory: 0,
                    parentColumnId: 'operator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'less_five_operator',
                    label: '<5',
                    fullName: '',
                    type: 'string',
                    level: 1,
                    isCategory: 0,
                    parentColumnId: 'operator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'five_to_ten_operator',
                    label: '5-10',
                    fullName: '',
                    type: 'string',
                    level: 1,
                    isCategory: 0,
                    parentColumnId: 'operator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'more_ten_operator',
                    label: '>10',
                    fullName: '',
                    type: 'string',
                    level: 1,
                    isCategory: 0,
                    parentColumnId: 'operator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_operator',
                    label: 'Всего',
                    fullName: '',
                    type: 'string',
                    level: 1,
                    isCategory: 0,
                    parentColumnId: 'operator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'administrator',
                    label: 'Администратор филиала',
                    fullName: 'Администратор филиала',
                    type: 'string',
                    isCategory: 1,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'corf_administrator',
                    label: 'КОРФ',
                    fullName: 'КОРФ',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'administrator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load_administrator',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'administrator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employees_administrator',
                    label: 'Сотр.',
                    fullName: 'Сотрудники',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'administrator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'number_orders_administrator',
                    label: 'Кол-во заказов',
                    fullName: 'Количество заказов',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'administrator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'less_five_administrator',
                    label: '<5',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'administrator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'five_to_ten_administrator',
                    label: '5-10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'administrator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'more_ten_administrator',
                    label: '>10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'administrator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_administrator',
                    label: 'Всего',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'administrator',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'suhi',
                    label: 'Повар-сушист',
                    fullName: '',
                    type: 'string',
                    isCategory: 1,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'corf_suhi',
                    label: 'КОРФ',
                    fullName: 'КОРФ',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load_suhi',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employees_suhi',
                    label: 'Сотр.',
                    fullName: 'Сотрудники',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employess_with_norm_suhi',
                    label: 'Сотр. с норм.',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'proceeds_suhi',
                    label: 'Выручка',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'less_five_suhi',
                    label: '<5',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'five_to_ten_suhi',
                    label: '5-10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'more_ten_suhi',
                    label: '>10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_suhi',
                    label: 'Всего',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'suhi',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'pizzamaker',
                    label: 'Повар-пиццемейкер',
                    fullName: 'Повар-пиццемейкер',
                    type: 'string',
                    isCategory: 1,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'corf_pizzamaker',
                    label: 'КОРФ',
                    fullName: 'КОРФ',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load_pizzamaker',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employees_pizzamaker',
                    label: 'Сотр.',
                    fullName: 'Сотрудники',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employess_with_norm_pizzamaker',
                    label: 'Сотр. с норм.',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'number_pizzas_pizzamaker',
                    label: 'Количество пицц',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'less_five_pizzamaker',
                    label: '<5',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'five_to_ten_pizzamaker',
                    label: '5-10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'more_ten_pizzamaker',
                    label: '>10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_pizzamaker',
                    label: 'Всего',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'pizzamaker',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'hot',
                    label: 'Горячий цех',
                    fullName: '',
                    type: 'string',
                    isCategory: 1,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'corf_hot',
                    label: 'КОРФ',
                    fullName: 'КОРФ',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'hot',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load_hot',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'hot',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employees_hot',
                    label: 'Сотр.',
                    fullName: 'Сотрудники',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'hot',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'proceeds_hot',
                    label: 'Выручка',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'hot',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'less_five_hot',
                    label: '<5',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'hot',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'five_to_ten_hot',
                    label: '5-10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'hot',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'more_ten_hot',
                    label: '>10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'hot',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_hot',
                    label: 'Всего',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'hot',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'driver',
                    label: 'Водитель',
                    fullName: '',
                    type: 'string',
                    isCategory: 1,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'corf_driver',
                    label: 'КОРФ',
                    fullName: 'КОРФ',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'driver',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'load_driver',
                    label: 'Нагрузка',
                    fullName: 'Нагрузка',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'driver',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'employees_driver',
                    label: 'Сотр.',
                    fullName: 'Сотрудники',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'driver',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'number_orders_driver',
                    label: 'Кол-во заказов',
                    fullName: 'Количество заказов',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'driver',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'less_five_driver',
                    label: '<5',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'driver',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'five_to_ten_driver',
                    label: '5-10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'driver',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'more_ten_driver',
                    label: '>10',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'driver',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_driver',
                    label: 'Всего',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 1,
                    parentColumnId: 'driver',
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'inTotal',
                    label: 'Итого',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    level: 0,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'less_five_inTotal',
                    label: 'Низкая',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    parentColumnId: 'inTotal',
                    level: 1,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'five_to_ten_inTotal',
                    label: 'Средняя',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    parentColumnId: 'inTotal',
                    level: 1,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'more_ten_inTotal',
                    label: 'Высокая',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    parentColumnId: 'inTotal',
                    level: 1,
                    colspan: 1,
                    characteristic: '',
                },
                {
                    id: 'total_inTotal',
                    label: 'Всего',
                    fullName: '',
                    type: 'string',
                    isCategory: 0,
                    parentColumnId: 'inTotal',
                    level: 1,
                    colspan: 1,
                    characteristic: '',
                },
            ],
            records: [
                {
                    total: {
                        value: '<12',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '12-13',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: 0,
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 911.8,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: 0,
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '13-14',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '14-15',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '15-16',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '16-17',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '17-18',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '18-19',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '19-20',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '20-21',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '21-22',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '22-23',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '>23',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: '',
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: '',
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: '',
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: '',
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: '',
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: '',
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: '',
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: '',
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: '',
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: '',
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: '',
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: '',
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isShowRow: true,
                },
                {
                    total: {
                        value: '',
                    },
                    corf_operator: {
                        value: 0,
                    },
                    load_operator: {
                        value: 0,
                    },
                    employees_operator: {
                        value: 0,
                    },
                    number_orders_operator: {
                        value: 0,
                    },
                    less_five_operator: {
                        value: 0,
                    },
                    five_to_ten_operator: {
                        value: 0,
                    },
                    more_ten_operator: {
                        value: 0,
                    },
                    total_operator: {
                        value: 0,
                    },
                    corf_administrator: {
                        value: 0,
                    },
                    load_administrator: {
                        value: 0,
                    },
                    employees_administrator: {
                        value: 0,
                    },
                    number_orders_administrator: {
                        value: 0,
                    },
                    less_five_administrator: {
                        value: 0,
                    },
                    five_to_ten_administrator: {
                        value: 0,
                    },
                    more_ten_administrator: {
                        value: 0,
                    },
                    total_administrator: {
                        value: 0,
                    },
                    corf_suhi: {
                        value: 0,
                    },
                    load_suhi: {
                        value: 0,
                    },
                    employees_suhi: {
                        value: 0,
                    },
                    employess_with_norm_suhi: {
                        value: 0,
                    },
                    less_five_suhi: {
                        value: 0,
                    },
                    five_to_ten_suhi: {
                        value: 0,
                    },
                    more_ten_suhi: {
                        value: 0,
                    },
                    total_suhi: {
                        value: 0,
                    },
                    corf_pizzamaker: {
                        value: 0,
                    },
                    load_pizzamaker: {
                        value: 0,
                    },
                    employees_pizzamaker: {
                        value: 0,
                    },
                    employess_with_norm_pizzamaker: {
                        value: 0,
                    },
                    number_pizzas_pizzamaker: {
                        value: 0,
                    },
                    less_five_pizzamaker: {
                        value: 0,
                    },
                    five_to_ten_pizzamaker: {
                        value: 0,
                    },
                    more_ten_pizzamaker: {
                        value: 0,
                    },
                    total_pizzamaker: {
                        value: 0,
                    },
                    corf_hot: {
                        value: 0,
                    },
                    load_hot: {
                        value: 0,
                    },
                    employees_hot: {
                        value: 0,
                    },
                    proceeds_hot: {
                        value: 0,
                    },
                    proceeds_suhi: {
                        value: 0,
                    },
                    less_five_hot: {
                        value: 0,
                    },
                    five_to_ten_hot: {
                        value: 0,
                    },
                    more_ten_hot: {
                        value: 0,
                    },
                    total_hot: {
                        value: 0,
                    },
                    corf_driver: {
                        value: 0,
                    },
                    load_driver: {
                        value: 0,
                    },
                    employees_driver: {
                        value: 0,
                    },
                    number_orders_driver: {
                        value: 0,
                    },
                    less_five_driver: {
                        value: 0,
                    },
                    five_to_ten_driver: {
                        value: 0,
                    },
                    more_ten_driver: {
                        value: 0,
                    },
                    total_driver: {
                        value: 0,
                    },
                    less_five_inTotal: {
                        value: 0,
                    },
                    five_to_ten_inTotal: {
                        value: 0,
                    },
                    more_ten_inTotal: {
                        value: 0,
                    },
                    total_inTotal: {
                        value: 0,
                    },
                    isTotalRow: true,
                    isShowRow: true,
                },
            ],
        },
        isFirstLoading: true,
    },
    mutations: {
        setColumns(state, columns) {
            state.columns = columns;
        },
        setPermissions(state, columns) {
            state.permissions = columns;
        },

        setUserColumns(state, columns) {
            state.userColumns = columns;
        },

        setRecords(state, records) {
            state.records = records;
        },

        setStat(state, stat) {
            state.stat = stat;
        },
        setFirstLoadingToFalse(state) {
            state.isFirstLoading = false;
        },
    },
    getters: {
        getColumns(state) {
            return state.columns;
        },

        getPermissions(state) {
            return state.permissions;
        },

        getUserColumns(state) {
            return state.userColumns;
        },

        getRecords(state) {
            return state.records;
        },

        getStat(state) {
            return state.stat;
        },

        getTableMainTableCalculationByDate(state) {
            return state.mainTableCalculationByDate;
        },

        getTableMainTableCalculationByPeriod(state) {
            return state.mainTableCalculationByPeriod;
        },

        getTableProductionsCreateCalculation(state) {
            return state.tableProductionNewCalculation;
        },

        getTableProductionsByPeriod(state) {
            return state.tableProductionByPeriod;
        },

        getTableDeliveryByPeriod(state) {
            return state.tableDeliveryByPeriod;
        },

        getTableDeliveryCreateCalculation(state) {
            return state.tableDeliveryNewCalculation;
        },

        getTableLatenessCreateCalculation(state) {
            return state.tableLatenessNewCalculation;
        },
    },
    actions: {
        async getPermissions(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation/permissions`, token),
            );

            const json = await res.json();

            return json;
        },

        async getTypeLoadReference(ctx) {
            const token = ctx.rootState.authToken;

            const res = await axios.get(
                addAuthKey(`${api_url}/?r=api/type-load/index`, token));
            return res.data;
        },

        async getStat(ctx, params) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation/stat&${params[0]}`,
                    token),
                {
                    method: 'get',
                },
            );

            const json = await res.json();

            ctx.commit('setStat', json);

            return json;
        },

        async getRecords(ctx, params) {
            const token = ctx.rootState.authToken;
            const {userId} = ctx.rootState;

            const form_data = new FormData();
            const page = params[0];
            const sort_by = params[1];
            const sort_type = params[2];
            const {globalFilters} = params[3];
            const localFilters = [...params[3].localFilters];
            const isExport = params[4] === undefined ? 0 : params[4];
            const tab = params[5] === undefined ? 'list' : params[5];

            const appendFilters = (filters, filtersName) => {
                filters.forEach(item => {
                    const filterName = item.id.split('_')[0];
                    if (
                        item.type === 'list' &&
                        item.id === 'postCategorySpecialty'
                    ) {
                        const values = item.value.map(item => item.id).
                            join(',');
                        form_data.append(
                            `${filtersName}[posts][search_type]`,
                            item.searchType,
                        );
                        form_data.append(
                            `${filtersName}[posts][values]`,
                            values,
                        );
                    } else if (item.type === 'list') {
                        if (item.id === 'workerType') {
                            form_data.append(
                                `${filtersName}[${filterName}][value]`,
                                item.value[0].id,
                            );
                        } else {
                            let values = item.value.map(item => item.id);
                            values = values.filter(
                                (v, i) => values.indexOf(v) === i).join(',');
                            form_data.append(
                                `${filtersName}[${filterName}][search_type]`,
                                item.searchType,
                            );
                            form_data.append(
                                `${filtersName}[${filterName}][values]`,
                                values,
                            );
                        }
                    } else if (
                        item.type === 'number' &&
                        item.searchType === '4'
                    ) {
                        form_data.append(
                            `${filtersName}[${filterName}][value]`,
                            item.value.start,
                        );
                        form_data.append(
                            `${filtersName}[${filterName}][search_type]`,
                            item.searchType,
                        );
                        form_data.append(
                            `${filtersName}[${filterName}][value_2]`,
                            item.value.end,
                        );
                    } else if (item.type === 'boolean') {
                        if (item.value === '1')
                            form_data.append(
                                `${filtersName}[${filterName}][value]`,
                                item.value,
                            );
                    } else {
                        form_data.append(
                            `${filtersName}[${filterName}][value]`,
                            item.value,
                        );
                        form_data.append(
                            `${filtersName}[${filterName}][search_type]`,
                            item.searchType,
                        );
                    }
                });
            };

            const appendFiltersGlobal = (filters, filtersName) => {
                Object.keys(filters).forEach(key => {
                    const filterName = key;
                    const item = filters[key];
                    if (filterName === 'shift') {
                        form_data.append(
                            `${filtersName}[${filterName}][value]`,
                            item.value,
                        );
                    } else if (filterName === 'branchesReverse') {
                        form_data.append(
                            `${filtersName}[${filterName}][value]`,
                            item ? 1 : 0,
                        );
                    } else if (filterName === 'branches') {
                        let values = item.map(item => item.value);
                        values = values.filter(
                            (v, i) => values.indexOf(v) === i).join(',');
                        form_data.append(
                            `${filtersName}[${filterName}][values]`,
                            values,
                        );
                    } else if (filterName === 'period') {
                        if (typeof item === 'string') {
                            form_data.append(
                                `${filtersName}[${filterName}][value]`,
                                item,
                            );
                        }
                    }
                });
            };

            appendFiltersGlobal(globalFilters, 'filters');

            if (globalFilters.length > 0 || localFilters.length > 0) {
                appendFilters(localFilters, 'col_filters');
            }

            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/list&user_id=${userId}&sort_by=${sort_by}&sort_type=${sort_type}&page=${page}&is_export=${isExport}&tab=${tab}`,
                    token),
                {
                    method: 'post',
                    body: form_data,
                },
            );

            const json = await res.json();

            if (isExport !== 1) {
                ctx.commit('setRecords', json);
            } else {
                ctx.commit('setRecords', 'isExportExcel');
            }

            return json;
        },

        async getColumns(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation/columns`, token),
            );

            const json = await res.json();

            ctx.commit('setColumns', json.columns);
        },

        async getUserColumns(ctx) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/user-columns&user_id=${userId}`,
                    token),
            );

            const json = await res.json();

            ctx.commit('setUserColumns', json.columns);
        },

        async getUserColumnsByType(ctx, type) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/user-columns&type=${type}`,
                    token),
            );

            const json = await res.json();
            return json;
            ctx.commit('setUserColumns', json.columns);
        },

        async saveUserColumns(ctx, columns) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const form_data = new FormData();

            form_data.append('columns', JSON.stringify(columns));
            form_data.append('user_id', userId);

            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/save-user-columns&auth_key=${token}`,
                    token),
                {
                    method: 'post',
                    body: form_data,
                },
            );

            const json = await res.json();

            if (json.response) {
                ctx.commit('setUserColumns', columns);
            }
            return columns;
        },

        async getCalc(ctx, calcId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/get-calc&id=${calcId}`,
                    token),
            );

            const json = await res.json();

            return json;
        },

        async removeCalc(ctx, calcId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/remove-calc&calc_id=${calcId}`,
                    token),
            );

            const json = await res.json();

            ctx.commit('setActionStatus', json);
        },

        async getCountCalc(ctx, params) {
            const token = ctx.rootState.authToken;
            const {periodStart} = params;
            const {periodEnd} = params;
            const {filialId} = params;
            const {smena} = params;

            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/count-calc&filial_id=${filialId}&date=${periodStart}&dateend=${periodEnd}&smena=${smena}`,
                    token),
            );

            const json = await res.json();

            return json;
        },

        async getAll(ctx, params) {
            const token = ctx.rootState.authToken;
            let date = params.date;
            let filialId = params.filialId;
            let smena = params.smena;
            let timeStart = params.timeStart;
            let timeEnd = params.timeEnd;
            let recountRoutes = params.recountRoutes ? '&recalc_routes=1' : '';

            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/get-all&filial_id=${filialId}&date=${date}&smena=${smena}&timebeg=${timeStart}&timeend=${timeEnd}${recountRoutes}`,
                    token),
            );

            const json = await res.json();

            return json;
        },

        async checkExists(ctx, params) {
            const token = ctx.rootState.authToken;
            let date = params.date;
            let filialId = params.id;
            let smena = params.smena;

            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/check-exists&id=${filialId}&date=${date}&smena=${smena}`,
                    token),
            );

            const json = await res.json();

            return json;
        },

        async getOrdersRoutesData(ctx, params) {
            const token = ctx.rootState.authToken;
            const {filialId} = params;
            const {workerId} = params;
            const {date} = params;
            const {dateend} = params;

            let res;
            if (dateend) {
                res = await fetch(
                    addAuthKey(
                        `${api_url}/?r=api/calculation/get-orders-driver&worker_id=${workerId}&date=${date}&dateend=${dateend}&filial_id=${filialId}`,
                        token),
                );
            } else {
                res = await fetch(
                    addAuthKey(
                        `${api_url}/?r=api/calculation/get-orders-driver&worker_id=${workerId}&date=${date}&filial_id=${filialId}`,
                        token),
                );
            }

            const json = await res.json();

            return json;
        },

        async getOrdersRoutesLatenessData(ctx, orders) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/get-orders-routes&orders=${JSON.stringify(
                        orders,
                    )}`, token),
            );

            const json = await res.json();

            return json;
        },

        async saveCalculation(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            const recursiveFormatIntervals = (obj) => {
                if (Array.isArray(obj)) {
                    return obj.map(item => recursiveFormatIntervals(item));
                } else if (obj && typeof obj === 'object') {
                    const result = {};
                    for (const [k, v] of Object.entries(obj)) {
                        if (k === 'start' || k === 'finish') {
                            if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(v)) {
                                const date = new Date(v);
                                const hours = String(date.getHours()).padStart(2, '0');
                                const minutes = String(date.getMinutes()).padStart(2, '0');
                                result[k] = `${hours}:${minutes}`;
                            } else if (v && typeof v === 'object' && typeof v.format === 'function' && v._isAMomentObject) {
                                result[k] = v.format('HH:mm');
                            } else {
                                result[k] = v;
                            }
                        } else {
                            result[k] = recursiveFormatIntervals(v);
                        }
                    }
                    return result;
                }
                return obj;
            };
            
            const conversionCalculation = recursiveFormatIntervals(params.calculation);

            form_data.append('d', JSON.stringify(conversionCalculation));
            if (params.confirm === 1) form_data.append('confirm', 1);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation/save`, token), {
                    method: 'post',
                    body: form_data,
                });

            const json = await res.json();

            return json;
        },

        async changeCourier(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            form_data.append('order_id', params.order_id);
            form_data.append('courier_id', params.courier_id);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation/change-courier`,
                    token), {
                    method: 'post',
                    body: form_data,
                });

            const json = await res.json();

            return json;
        },

        async recalcDriver(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();

            form_data.append('id', params.id);
            form_data.append('driverID', params.driverID);
            form_data.append('date', params.date);
            form_data.append('timeend', params.timeend);
            form_data.append('timebeg', params.timebeg);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation/recalc-driver`,
                    token), {
                    method: 'post',
                    body: form_data,
                });

            const json = await res.json();

            return json;
        },

        async getPersonalAccountHistoryCalculationByPeriod(ctx, params) {
            const token = ctx.rootState.authToken;
            const {filialId} = params;
            const {periodStart} = params;
            const {periodEnd} = params;
            const {workerId} = params;

            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/get-personal-history&filial_id=${filialId}&date=${periodStart}&dateend=${periodEnd}&worker_id=${workerId}`,
                    token),
            );

            const json = await res.json();

            return json;
        },

        async getFineInfoForWorker(ctx, params) {
            const token = ctx.rootState.authToken;
            const {workerId} = params;
            const {reasonId} = params;
            const {type} = params;
            const res = await fetch(
                addAuthKey(
                    `${api_url}/?r=api/calculation/sum-penalty&worker_id=${workerId}&reason_id=${reasonId}&type=${type}`,
                    token),
            );

            const json = await res.json();

            return json;
        },

        async addWorkerInCalculation(ctx, params) {
            const token = ctx.rootState.authToken;
            const form_data = new FormData();
            form_data.append('name', params.name);
            form_data.append('post_code', params.post_code);
            form_data.append('filial_id', params.filial_id);
            form_data.append('type', params.type);
            form_data.append('date', params.date);
            form_data.append('calc_id', params.calc_id);
            form_data.append('smena', params.smena);

            if (params.category_id && params.category_id.length > 0) {
                form_data.append('category_id', params.category_id);
            }

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation/add-worker`, token), {
                    method: 'post',
                    body: form_data,
                });

            const json = await res.json();
            return json;
        },

        async getPositionIntervals() {
            // const token = ctx.rootState.authToken;
            // const formData = serialize({ Position: params.positionCode });

            const testData = {
                intervals: [
                    {
                        id: 1,
                        interval: '11:00 – 15:00',
                        total: {
                            ordersCount: 28,
                            load: 160000,
                            revenueStandart: 170000,
                            finesAndBonuses: -2000,
                        },
                        employees: [
                            {
                                id: 1,
                                name: 'Сланов Александр Андреевич',
                                ordersCount: null,
                                load: null,
                                revenueStandart: 85000,
                                finesAndBonuses: 1000,
                            },
                            {
                                id: 2,
                                name: 'Туаев Тамази Нугзарович',
                                ordersCount: null,
                                load: null,
                                revenueStandart: 85000,
                                finesAndBonuses: -3000,
                            },
                        ],
                    },
                    {
                        id: 2,
                        interval: '15:00 – 23:00',
                        total: {
                            ordersCount: 72,
                            load: 380000,
                            revenueStandart: 390000,
                            finesAndBonuses: -2000,
                        },
                        employees: [
                            {
                                id: 1,
                                name: 'Сланов Александр Андреевич',
                                ordersCount: null,
                                load: null,
                                revenueStandart: 130000,
                                finesAndBonuses: 0,
                            },
                            {
                                id: 2,
                                name: 'Туаев Тамази Нугзарович',
                                ordersCount: null,
                                load: null,
                                revenueStandart: 130000,
                                finesAndBonuses: -1000,
                            },
                            {
                                id: 3,
                                name: 'Боциев Олег Максимович',
                                ordersCount: null,
                                load: null,
                                revenueStandart: 130000,
                                finesAndBonuses: -1000,
                            },
                        ],
                    },
                ],
            };

            return new Promise(res => {
                setTimeout(() => res(testData), 2000);
            });

        },

        async getCalculationVersions(ctx, calcId) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/calculation/versions-list&calc_id=${calcId}`, token), {
                method: 'GET',
            });
            return await res.json();
        },

        async getCalculationVersion(ctx, {calcId, versionId}) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/calculation/get-calculation-version`, token), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    calc_id: calcId,
                    version_id: versionId
                }),
            });
            return await res.json();
        },

        async toggleCalculationClosed(ctx, calcId) {
            const token = ctx.rootState.authToken;
            const formData = new FormData();
            formData.append('calc_id', calcId);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation/toggle-closed`, token),
                { method: 'POST', body: formData },
            );
            return await res.json();
        },
    },
};
